import React from "react";
import { useTranslation } from "react-i18next";
import ErrorPage from "components/errors/ErrorPage";
import useProductName from "brand-customization/useProductName";
import Center from "components/common/Center";
const PageErrorOverview = ({ error, title = void 0 }) => {
  const { t } = useTranslation("common");
  const productName = useProductName();
  const description = /* @__PURE__ */ React.createElement("p", null, t("errors.page_error_description"));
  return /* @__PURE__ */ React.createElement(ErrorPage, { title: title != null ? title : t("errors.page_error_title"), description, displayPageLayout: false }, /* @__PURE__ */ React.createElement("pre", null, error.toString()), /* @__PURE__ */ React.createElement(Center, null, t("errors.page_error_logs", { productName })));
};
export default PageErrorOverview;
